import { IAction } from '@interface/IAction';

export const actionType = Object.freeze({

    INIT_FUNDER_PAGE: 'funder.initialize-funder-page',

    GET_FUNDER_DETAIL: 'funder.get-funder-detail',
    SET_FUNDER_DETAIL: 'funder.set-funder-detail',

    GET_FUNDER_AGREEMENT: 'funder.get-funder-agreement',
    SET_FUNDER_AGREEMENT: 'funder.set-funder-agreement',

    GET_FREE_CASH_BALANCE_SUMMARY: 'funder.get-free-cash-balance-summary',
    SET_FREE_CASH_BALANCE_SUMMARY: 'funder.set-free-cash-balance-summary',
});

export function getFreeCashBalanceSummary(): IAction {
    return {
        type: actionType.GET_FREE_CASH_BALANCE_SUMMARY,
        payload: {}
    }
}

export function setFreeCashBalance(payload): IAction {
    return {
        type: actionType.SET_FREE_CASH_BALANCE_SUMMARY,
        payload
    }
}

export function getFunderDetail(): IAction {
    return {
        type: actionType.GET_FUNDER_DETAIL
    }
}

export function setFunderDetail(payload): IAction {
    return {
        type: actionType.SET_FUNDER_DETAIL,
        payload
    }
}

export function getFunderAgreementUrl(): IAction {
    return {
        type: actionType.GET_FUNDER_AGREEMENT
    }
}

export function setFunderAgreementUrl(payload): IAction {
    return {
        type: actionType.SET_FUNDER_AGREEMENT,
        payload
    }
}

export function initFunderPage(): IAction {
    return {
        type: actionType.INIT_FUNDER_PAGE
    }
}